<script>
	export let songCollectionObject;
    export let songSelected;
</script>

<ul>
	{#if Array.isArray(songCollectionObject)}
		{#each songCollectionObject as songNameString}
			<li><span class="song" on:click={() => songSelected = songNameString}>{songNameString}</span></li>
		{/each}
	{:else}
		{#each Object.entries(songCollectionObject) as [key, value]}
			<li>
				<details>
					<summary>{key}</summary>
					<svelte:self songCollectionObject={value} bind:songSelected />
				</details>
			</li>
		{/each}
	{/if}
</ul>

<style>
	ul {
		list-style-type: none;
	}

	summary {
		cursor: pointer;
	}

	.song::before {
		content: "•";
		display: inline-block;
		margin-right: 0.5rem;
		text-decoration: none;
		color: black;
	}

	.song {
		cursor: pointer;
		text-decoration: underline;
		color: dodgerblue;
	}
</style>